<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Responsáveis' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content padding>
  <div class="gradient-extendido"></div>

  <ion-grid>
    <ion-list *ngFor="let r of responsavelList">
      <ion-item>
        <ion-avatar slot="start">
          <img [src]="r.foto | image:' '" />
        </ion-avatar>

        <ion-label class="edit-text">
          <h3>{{r.nome}}</h3>
          <p>{{'Responsável' | translate}}</p>
        </ion-label>

        <ion-note slot="end" (click)="selecionarPessoa(r)">
          <i class="fa-solid fa-ellipsis-vertical"></i>
        </ion-note>
      </ion-item>
    </ion-list>

    <sem-registro [text]=" 'Nenhum Responsável Cadastrado' | translate " *ngIf="!responsavelList.length"></sem-registro>

    <ion-row class="ion-justify-content-center">
      <ion-col size="9" class="ion-text-center">
        <ion-button shape="round" class="btn-custom-icon" (click)="add()">
          {{'Adicionar Responsável' | translate}}

          <ion-icon name="add"></ion-icon>
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer class="ion-no-border">
  <ion-toolbar>
    <ion-grid>
      <ion-row>
        <ion-col size="12" *ngIf="!acompanhamento.id">
          <ion-button shape="round" expand="block" class="btn-default" (click)="finalizar()" >
            {{'Finalizar' | translate}}
          </ion-button>
        </ion-col>

        <ion-col size="12" *ngIf="acompanhamento.id">
          <ion-button shape="round" expand="block" class="btn-default" (click)="salvar()">
            {{'Salvar' | translate}}
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-toolbar>
</ion-footer>
